<template>
  <div>
    <header class="bim-header" ref="header">
      <bim-top-banner-line />
      <bim-container>
        <div class="bim-header-content head-flex" :class="{ w100: w100 }">

          <!-- Логотип -->
          <div class="head-flex-auto">
            <div class="bim-logo" @click="logoClicked" v-html="require('@/assets/img/bim-logo.svg')" />
          </div>

          <!-- Ссылки меню -->
          <HeadLinks
            class="link-group-wrp"
            :links="headerLinks"
            :headerLinkTarget="headerLinkTarget"
            :logActionEvent="logActionEvent"
          />

          <div class="head-flex-auto" v-if="$slots.left">
            <!-- @slot - -->
            <slot name="left"></slot>
          </div>

          <div class="head-flex-item flex-grow-1">
          </div>

          <div class="head-flex-auto" v-if="$slots.right">
            <!-- @slot - -->
            <slot name="right"></slot>
          </div>

          <div class="head-flex-auto flex-grow-0 phone-wrp">
            <a class="head-tel" href="tel:88005002575" @click="logActionEvent('headerClickPhone')">
              <div class="head-tel__icon" v-html="require('@/assets/img/phone.svg')" />
              8 800 500-25-75
            </a>
          </div>

          <!-- Уведомления -->
          <bimNotices
            v-if="user && showNotices"
            :apiHost="apiHost"
            class="notice-wrp"
            :user="user"
            :logActionEvent="logActionEvent"
            @updateContext="updateContext"
          />

          <!-- Аватар пользователя с выпадающим меню при наведении -->
          <div
            v-if="user"
            class="head-flex-auto user-info"
            :class="{opened: show.userMenu}"
            @mouseover="show.userMenu=true"
            @mouseleave="show.userMenu=false"
            @click="show.userMenu=!show.userMenu"
          >
            <div class="head-flex-auto">
              <Avatar
                :user="user"
                :imgHost="imgHost"
              />
            </div>
            <div class="arrow-down" :class="{ up: show.userMenu }"></div>
            <!--Выпадающее меню-->
            <div class="user-menu-wrp" v-show="show.userMenu" @click.stop @mouseleave="show.userMenu=false">
              <div class="menu-item" v-if="showMenuItem('home')" @click="menuItemClicked('home')">
                <div class="flex-grow-1 menu-text">
                  {{$bimTranslate('header.personalAccount', activeLang)}}
                </div>
              </div>

              <div class="menu-item" v-if="showMenuItem('models')" @click="menuItemClicked('models')">
                <div class="flex-grow-1 menu-text">
                  {{$bimTranslate('header.models', activeLang)}}
                </div>
              </div>

              <div class="menu-item" v-if="showMenuItem('statistic')" @click="menuItemClicked('statistic')">
                <div class="flex-grow-1 menu-text">
                  {{$bimTranslate('header.statistics', activeLang)}}
                </div>
              </div>

              <div class="menu-item d-flex" v-if="showMenuItem('logout')" @click="menuItemClicked('logout')">
                <div
                  class="flex-grow-0 menu-icon"
                  v-html="require('@/assets/img/header/logout.svg')"
                />
                <div class="flex-grow-1 menu-text">
                  {{$bimTranslate('header.logout', activeLang)}}
                </div>
              </div>
            </div>
          </div>
          <div v-else class="head-flex-auto login-wrp" @click="loginClicked">
            <span class="login-wrp__text">
              <span class="login-wrp__icon" v-html="require('@/assets/img/login.svg')" />
              {{$bimTranslate('header.login', activeLang)}}
            </span>
            <i class="login-wrp__icon" />
          </div>
          <div class="hamburger" @click="handleMobileMenu" />
        </div>
        <MobileMenu
          v-if="show.mobileMenu"
          @login-clicked="loginClicked"
          @change-lang="changeLang"
          @menuItemClicked="menuItemClicked"
          @socialLinkClick="socialLinkClick"
          :user="user"
          :links="headerLinks"
          :headerLinkTarget="headerLinkTarget"
          :activeLang="activeLang"
          :makeChangeLanguage="makeChangeLanguage"
          :imgHost="imgHost"
          :handleMobileMenu="handleMobileMenu"
        />
      </bim-container>
    </header>
    <div :style="`height: ${headerHeight}px`"></div>
  </div>
</template>

<script>
// import ChangeLang from '@/components/core/bimHeader/ChangeLang'
 import MobileMenu from '@/components/core/bimHeader/MobileMenu'
import HeadLinks from '@/components/core/bimHeader/HeadLinks'
import bimContainer from '@/components/grid/bimContainer/bimContainer'
import { enumLang } from '@/components/core/translate.plugin/enumLang'
import Avatar from '@/components/core/bimHeader/Avatar'

import bimNotices from '@/components/ui/bimNotices/bimNotices'
import bimTopBannerLine from '@/components/ui/bimTopBannerLine/bimTopBannerLine'

export default {
  name: 'bimHeader',
  components: {
    bimContainer,
    bimNotices,
    HeadLinks,
    MobileMenu,
    // ChangeLang,
    Avatar,
    bimTopBannerLine
  },
  props: {
    /**
     * Логирующая функция для /log/event/
     */
    logActionEvent: {
      type: Function,
      default: () => {}
    },
    /**
     * Показывать 'колокольчик'
     */
    showNotices: {
      type: Boolean,
      default: false
    },
    /**
     * Возможность смены языка
     */
    makeChangeLanguage: {
      type: Boolean,
      default: true
    },
    /**
     * Адрес основного домена (использовать если домен отличается от основного сайта)
     */
    bimlibHost: {
      type: String,
      default: ''
    },
    /**
     * Адресс апи
     */
    apiHost: {
      type: String,
      default: '/api'
    },
    /**
     * Префикс до изображений Аватарки и логотипа компании
     */
    imgHost: {
      type: String,
      default: '/api/assets/images/'
    },
    /**
     * Адреса ссылок в шапке
     * Array<link[]>{ linkRu: String, linkEng: String, url: String, links: Array<link[]> || [] },
     */
    headLinks: {
      type: Array,
      default: () => [
        {
          linkRu: 'Главная',
          linkEng: 'Home',
          url: '/',
          eventName: 'headerClickItemHome',
        },
        {
          linkRu: 'BIM-<wbr>модели',
          linkEng: 'BIM-<wbr>models',
          url: '/models/',
          eventName: 'headerClickItemBimModels',
        },
        {
          linkRu: 'Плагины',
          linkEng: 'Plugins',
          url: '/plugins/',
        },
        {
          linkRu: 'Читальный <wbr>зал',
          linkEng: 'Reading <wbr>Room',
          url: '/articles/',
          eventName: 'headerClickItemArticles',
          links: [
            {
              linkRu: 'Партнёрские <wbr>программы',
              linkEng: 'Partners <wbr>programm',
              url: '/partners/',
              eventName: 'headerClickItemPartners',
            },
          ],
        },
        {
          separator: true,
          linkRu: 'separator-1',
          linkEng: 'separator-1',
        },

        {
          linkRu: 'Производителям',
          linkEng: 'For <wbr>manufacturers',
          url: '/for-manufacturers/',
          eventName: 'headerClickItemForManufacturers',
          class: 'green-link',
          target: '_blank',
        },
      ]
    },
    /**
     * Объект пользователя
     * user { avatar: String, count_new_message: Number, firstName: String, lastName: String }
     */
    user: {
      type: Object,
      default: null
    },
    /**
     * Шапка на всю ширину
     */
    w100: {
      type: Boolean,
      default: false
    },
    /**
     * Текущий язык
     */
    activeLang: {
      type: String,
      default: 'ru',
      validator (value) {
        return ['ru', 'en'].indexOf(value) !== -1
      }
    },
    /**
     * Элементы меню выпадающего списка
     */
    dropDownItems: {
      type: Array,
      default: () => ['home', 'models', 'statistic', 'logout']
    }
  },
  data: () => ({
    show: {
      mobileMenu: false,
      userMenu: false
    },
    headerHeight: 64
  }),
  mounted () {
    this.initHeaderHide()
    document.addEventListener('click', this.onBodyClicked)
  },
  beforeDestroy () {
    document.removeEventListener('click', this.onBodyClicked)
  },
  computed: {
    headerLinkTarget () {
      return String(this.bimlibHost).indexOf('http') >= 0 ? 'blank' : ''
    },
    headerLinks () {
      const lang = this.activeLang

      const linkTranslate = link => {
        link.name = lang === enumLang.ru ? link.linkRu : link.linkEng
        if (link.links) {
          link.links.forEach(linkTranslate)
        }
        return link
      }

      return [].concat(this.headLinks).map(linkTranslate)
    }
  },
  methods: {
    updateContext (context) {
      /**
       * Обновление контекста пользователя
       * @param {Object} context контекст пользователя
       */
      this.$emit('updateContext', context)
    },
    socialLinkClick (name) {
      /**
       * Клик по иконке соц. сетей в мобильном меню<br/>
       * передает название соц. сети<br/>
       *
       * telegram, youtube, vk, telegram, linkedin, twitter
       * @param {String} name код соц. сети
       */
      this.$emit('socialLinkClick', name)
    },

    initHeaderHide () {
      const self = this
      const header = this.$refs.header
      const scrollHeader = {
        self,
        header,
        position: window.pageYOffset,
        headerDown () {
          this.header.classList.add('nav-down')
          this.header.classList.remove('nav-up')
          this.position = window.pageYOffset
        },
        headerUp () {
          setTimeout(() => {
            this.header.classList.add('nav-up')
            this.header.classList.remove('nav-down')
          }, 300)
          this.position = window.pageYOffset
        },
        init () {
          if (this.header) {
            window.addEventListener('scroll', () => {
              if (this.position < window.pageYOffset && window.pageYOffset >= 200) {
                this.headerUp()
              } else if (window.pageYOffset === 0) {
                setTimeout(() => {
                  this.headerDown()
                }, 1000)
              } else {
                this.headerDown()
              }
            })

            self.headerHeight = this.header?.offsetHeight ?? 0
            window.addEventListener('resize', () => {
              self.headerHeight = this.header?.offsetHeight ?? 0
            })
          }
        }
      }
      scrollHeader.init()
    },

    handleMobileMenu () {
      const show = this.show.mobileMenu
      this.show.mobileMenu = !show
      document.body.style.setProperty('overflow', show ? 'auto' : 'hidden', 'important')
    },

    showMenuItem (menuItem) {
      return ~this.dropDownItems.indexOf(menuItem)
    },

    logoClicked () {
      window.location = '/'
    },

    formLink (link) {
      return `${this.bimlibHost}${link}`
    },

    changeLang () {
      const nextLang = this.activeLang === enumLang.ru ? enumLang.eng : enumLang.ru

      /**
       * Возвращает язык на который переключили ('ru', 'en')
       * @param {string} nextLang
       */
      this.$emit('changeLanguage', nextLang)
    },

    loginClicked () {
      /**
       * Кликнули на кнопку войти
       * @param {void}
       */
      this.$emit('loginClicked')
      this.logActionEvent('headerClickLogin')
    },

    menuItemClicked (menuItem) {
      /**
       * Произошел клик по меню пользователя
       * @param {string} menuItem
       */
      this.$emit('userMenuClicked', menuItem)
      this.show.userMenu = false
    },

    onBodyClicked () {
      if (this.show.userMenu) {
        this.show.userMenu = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  $header-height: 64px;

  .hamburger {
    width: 18px;
    cursor: pointer;
    padding: 5px 0 5px 10px;

    @media (min-width: 961px) {
      display: none;
    }

    &::before, &::after {
      content: '';
      width: 100%;
      height: 2px;
      margin: 7px 0;
      display: block;
      background-color: #4d4d4d;
    }
  }

  .head-flex {
    display: flex;
    flex: 1;
    flex-direction: row;
    flex-wrap: nowrap;
  }

  .head-flex-item {
    flex: 1;
  }

  .head-flex-auto {
    flex: 0 0 auto;
  }

  .nav-up {
    top: -64px !important;
  }
  .nav-down {
    top: 0 !important;
  }

  .bim-header {
    width: 100%;
    font-weight: 500;
    font-family: 'Helvetica Neue', sans-serif;
    box-sizing: border-box;
    transition: top 0.5s ease;
    position: fixed;
    z-index: 1001;
    white-space: nowrap;
    color: $black-color;
    box-shadow: 0 5px 40px 0 rgba(0, 0, 0, 0.03);
    background: white;
    filter: drop-shadow(0px 15px 20px #E5ECEB);
  }

  .bim-header-content {
    height: $header-height;
    align-items: center;
  }

  .bim-header-content.w100 {
    max-width: 100%
  }

  .change-lang--desktop {
    @media screen and (max-width: $breakpoint-sm) {
      display: none !important;
    }
  }

  .bim-logo {
    cursor: pointer;
    margin-right: 20px;
    @media (min-width: 1280px) {
      margin-right: 40px;
    }
  }

  .bim-logo /deep/ svg {
    width: 95px
  }

  .phone-wrp {
    @media (min-width: 1280px) {
      padding: 0 24px 0 12px;
    }
  }

  .notice-wrp {
    margin-left: 6px;
  }

  .head-tel {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: $black-color;
    line-height: 1;
    letter-spacing: 0.2px;
    text-decoration: none;
    @media screen and (max-width: $breakpoint-sm) {
      font-size: 0;
    }
    @media (max-width: 1279px) and (min-width: 960px) {
      font-size: 0!important;
    }
    @media (max-width: 959px) and (min-width: 576px) {
      margin-right: 20px;
    }

    &__icon {
      font-size: 0;

      @media (min-width: 1280px) {
        margin-right: 7px;
      }
      @media (max-width: 959px) {
        margin-right: 7px;
      }
      @media (max-width: 1280px) {
        margin-left: 15px;
      }
    }
  }

  .head-menu /deep/ svg {
    display: block !important;
    width: 18px;
  }

  .head-menu {
    margin-left: 25px;
    cursor: pointer;
  }

  ::v-deep .link-group {
    height: $header-height;
    color: $black-color;
    line-height: 1.1;
    padding: 0 14px;
    font-size: 16px;
    height: 100%;
    display: flex;
    align-items: center;
    letter-spacing: 0.005em;
    transition: background-color 0.2s;
    text-decoration: none;
    white-space: pre;

    @media screen and (max-width: $breakpoint-xl) {
      padding: 0 14px;
    }
  }

  ::v-deep .link-group:hover {
    background: $white-color-100;
    cursor: pointer;
  }

  .link-group-wrp {
    display: none !important;
    position: relative;
  }

  .head-tel:hover {
    color: $primary-color;
    cursor: pointer;
  }

  .telegram-icon {
    margin-left: 12px;
    padding: 12px 11px 12px 10px;

    ::v-deep {
      svg path {
        width: 19px;
        height: 16px;
        fill: $white-color-900;
        cursor: pointer;
      }
      &:hover svg path {
        fill: $primary-color;
      }
    }
  }

  .user-info-text {
    flex: 1;
    position: relative;
    top: 1px;
    padding-right: 40px;
  }

  .user-info {
    margin: 0 24px;
    padding: 0 20px 0 8px;
    height: $header-height;
    align-items: center;
    position: relative;
    display: none !important;
  }

  .user-info.opened {
    background-color: #f6f6f6;
  }

  .user-info:hover {
    cursor: pointer;
    background-color: $white-color-100;
  }

  .user-fullname {
    font-size: 14px;
    font-weight: bold;
  }

  .message-info {
    color: $black-color;
    font-size: 12px;
    opacity: 0.5;
    line-height: 1.83;
    margin-top: 2px;
  }

  .login-wrp {
    display: flex;
    line-height: 1!important;

    &__text {
      display: flex;
      align-items: center;
    }

    &__icon {
      font-size: 0;
      margin-right: 7px;
    }
  }

  .login-wrp,
  .service-wrp {
    padding: 0 12px;
    height: $header-height;
    line-height: $header-height;
    font-size: 14px;
    letter-spacing: 0.2px;

    @media screen and (max-width: $breakpoint-xl) {
      padding: 0 14px;
    }
  }

  .telegram-icon,
  .login-wrp,
  .service-wrp {
    @media screen and (max-width: $breakpoint-lg) {
      display: none !important;
    }
  }

  .login-wrp:hover {
    cursor: pointer;
    background-color: $white-color-100;
    color: #000!important;
  }

  .service-wrp {
    color: white;
    background-color: $primary-color;

    @media screen and (max-width: $breakpoint-xl) and (min-width: $breakpoint-lg) {
      display: none !important;
    }
  }

  .service-wrp:hover {
    cursor: pointer;
    background-color: $primary-color-300;
  }

  .user-menu-wrp {
    font-weight: 700;
    line-height: 1.54;
    width: fit-content;
    position: absolute;
    right: 0;
    top: 100%;
    padding-top: 27px;
    cursor: default;
    z-index: 30;
    filter: drop-shadow(0px 15px 20px #E5ECEB);
    transform: scaleY(0);
    transform-origin: top;
    animation: ani 0.25s forwards;
    @keyframes ani {
      0% {
        transform: scaleY(0);
      }
      100% {
        transform: scaleY(1);
      }
    }
  }

  .arrow-down {
    transition: all .2s ease;
    position: absolute;
    top: 24px;
    right: 11px;
    width: 7px;
    height: 7px;
    border: 2px solid #252525;
    border-top: 0;
    border-right: 0;
    transform: rotate(-45deg);
  }

  .arrow-down.up {
    transform: rotate(-225deg);
    top: 28px;
    opacity: 0.5;
  }

  .search__block {
    padding: 10px;
    cursor: pointer;
    display: none !important;
  }

  .menu-item {
    font-weight: 500;
    font-size: 16px;
    cursor: pointer;
    color: #252525;
    display: flex;
    padding: 12px 24px;
    align-items: center;
    background-color: #fff;
    font-family: 'Helvetica Neue', sans-serif;
    transition: background-color 0.2s, color 0.2s;
    &:first-child {
      border-radius: 12px 12px 0 0;
    }
    &:last-child {
      border-radius: 0 0 12px 12px;
    }
    &:hover {
      color: #00AFA1;
      background-color: #E9FAF8;

      /deep/ svg {
        fill: #00AFA1;
      }
    }
  }

  .menu-icon /deep/ svg {
    display: block !important;
    max-width: 18px;
    margin-bottom: 1px;
    margin-right: 7px;
    fill: #3E3E3E;
    transition: fill 0.2s;
  }

  @media all and (min-width: $breakpoint-lg) {
    .bim-logo /deep/ svg {
      width: 115px
    }
    .head-menu {
      display: none !important;
    }
    .user-info,
    .search__block,
    .link-group-wrp {
      display: flex !important;
    }
    .head-tel {
      font-size: 15px;
    }
  }
</style>
